import React from "react";
import DisclosureCore from "../../../utils/disclosure/DisclosureCore";
import Paragraph from "../../../elements/p/Paragraph";
import Container from "../../../utils/Container";
import H3 from "../../../elements/titles/H3";

const CategoryAndProduct = () => {
  return (
    <Container classe="mt-3">
      <DisclosureCore title="Différence entre catégorie et produit">
        <Paragraph>
          La principale différence entre les catégories et les produits est que
          chaque produit appartiens à une catégorie. Et une catégorie peu
          contenir plusieurs produits.
        </Paragraph>
        <Paragraph classe="mt-3">
          Lorsque vous allez vouloir publier un nouveau produit, vous devez
          d'abord tenir compte de la catégorie à laquelle il appartient. Si
          cette catégorie existe déjà, vous pouvez simplement la sélectionner
          dans la liste déroulante des catégories sur le formulaire de création
          de produit. Sinon, vous devez d'abord créer cette catégorie avant de
          pouvoir créer votre produit.
        </Paragraph>
        <div className="mt-3">
          <H3>Pourquoi régouper les produits par catégories ?</H3>
          <Paragraph>
            Les produits sont régroupés en catégories pour 2 principales raisons
          </Paragraph>

          <ul className="mt-3">
            <li>
              <strong className="font-nunito text-base text-secondary">
                1. Récherche ciblé par les utilisateurs
              </strong>
              <Paragraph>
                Comme les produits sont regroupés par catégories, quand
                l'utilisateur cliquera sur une catégorie, on pourra l'afficher
                la liste des produits qui appartient à cette catégorie.
              </Paragraph>
            </li>
            <li className="mt-3">
              <strong className="font-nunito text-base text-secondary">
                2. La suppression facile par l'administrateur
              </strong>
              <Paragraph>
                S'il arrive que dans votre boutique vous avez par exemple
                publier plusieurs produits de télévision et que vous ne vendez
                plus de télévisions, au lieu supprimer chaque produit de
                télévisions un a un, vous pourrez supprimer la catégorie{" "}
                <span className="font-medium  underline">télevision</span> et
                cela va automatique supprimer tous les produits qui
                appartiennent à cette catégorie.
              </Paragraph>
            </li>
          </ul>
        </div>
      </DisclosureCore>
    </Container>
  );
};

export default CategoryAndProduct;
